import { Map } from 'immutable';

import verifyEmail from './verifyEmail';
import resetPassword from './resetPassword';
import invite from './invite';

export default function (state = Map(), action) {
  return state
    .update('verifyEmail', (newState) => verifyEmail(newState, action))
    .update('resetPassword', (newState) => resetPassword(newState, action))
    .update('invite', (newState) => invite(newState, action));
}



// WEBPACK FOOTER //
// ./reducers/main.js